import * as React from 'react';
import { ThemeProvider } from 'styled-components';
import * as queryString from 'query-string';
import { Analytics } from './components/common/Analytics';
import { GlobalProvider } from './GlobalProvider';
import theme from './styles/theme';
import { CONFIG } from './config';
import * as Cookies from 'js-cookie';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { StatisticsService } from './services/StatisticsService';

export const App = ({ children }) => {
  React.useEffect(() => {
    StatisticsService.injectGaAnalytics();
    StatisticsService.injectFacebookPixel();
    StatisticsService.injectGoogleTagManager('GTM-5G5VDMT', true);

    if (queryString.parse(location.search).wm) {
      Cookies.set('wm', queryString.parse(location.search).wm, CONFIG.COOKIE_CONFIG);
    }
    if (queryString.parse(location.search).wmtr) {
      Cookies.set('wmtr', queryString.parse(location.search).wmtr, CONFIG.COOKIE_CONFIG);
    }

    Cookies.set('wmref', encodeURIComponent(document.referrer), CONFIG.COOKIE_CONFIG);
  }, []);

  return (
    <GoogleReCaptchaProvider reCaptchaKey='6LfN8v4UAAAAAPoX8mMMwPw0lReggQPlbXfMsj5y'>
      <ThemeProvider theme={theme}>
        <GlobalProvider>
          {children}
          <Analytics />
        </GlobalProvider>
      </ThemeProvider>
    </GoogleReCaptchaProvider>
  );
};
